import { ViewModelCritica } from '../shared/models/viewModelCritica';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { MatPaginator, MatSnackBar, MatSort, MatTableDataSource } from '@angular/material';
import { ViewModelEnviaCobrancaNovo } from '../shared/models/enviaCobrancaNovo.model';
import { GerenciadorRegistroCobrancaService } from '../shared/services/gerenciadorRegistroCobrancaService';
import { ViewModelCriticaNovo } from '../shared/models/viewModelCriticaNovo';


export interface PeriodicElement {
  nome: string;
  cpf: string;
  mensagem: string;
}
const ELEMENT_DATA: PeriodicElement[] = [


];




@Component({
  selector: 'app-mensageriarelatoriocobrancacomerro',
  templateUrl: './mensageria-relatoriocobrancacomerro.component.html',
  styleUrls: ['./mensageria-relatoriocobrancacomerro.component.scss']
})


export class MensageriaRelatorioCobrancaComErroComponent implements OnInit {
  displayedColumns: string[] = ['cpf', 'nome', 'mensagem'];
  dataSource = new MatTableDataSource<any>();
  pageIndex = "";
  pageSize = "";
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  viewModelCriticaNovo: ViewModelCriticaNovo[] = [];
  loading = false;
  dataFormatada: string;
  dataVencimento: Date;
  inputCpf: boolean = false;
  cpf: string;
  viewModelEnviaCobrancaNovo: ViewModelEnviaCobrancaNovo = new ViewModelEnviaCobrancaNovo();
  today: Date = new Date();
  currentYear: number = this.today.getFullYear();
  currentMonth: number = this.today.getMonth();
  currentDay: number = this.today.getDate();
  minDate: Object = new Date(
    this.currentYear,
    this.currentMonth,
    this.currentDay
  );



  constructor(
    private readonly router: Router,
    private _snackBar: MatSnackBar,
    private readonly gerenciadorRegistroCobrancaService: GerenciadorRegistroCobrancaService,

  ) {

  }

  ngOnInit() {
  }

  resultadoCobranca() {
    console.log(this.dataVencimento, 'verifica data');
    if (this.dataVencimento == undefined) {
      this._snackBar.open('Informe o parâmetro data para realizar a busca!', 'X', {
        duration: 30000,
        panelClass: ['red-snackbar']
      })
      this.loading = false;
    } else {
      this.loading = true;
      this.formataDataAtual();
      this.gerenciadorRegistroCobrancaService.getRetornaCriticaEnvioEmail(this.dataFormatada).subscribe(retorno => {
        if (retorno) {
          this.viewModelCriticaNovo = retorno['data'];
          this.dataSource = new MatTableDataSource<ViewModelCriticaNovo>(this.viewModelCriticaNovo);
          //this.dataSource.data = [(new MatTableDataSource<ViewModelCriticaNovo>(retorno))];
          this.dataSource.paginator = this.paginator;
          this.inputCpf = true;
          this.loading = false;
          console.log('aqui', retorno);
          console.log('aqui', this.dataSource.data);


        }
      }, error => {
        this.loading = false;
        this._snackBar.open('Nao foi possivel trazer dados para a data selecionada', 'X', {
          duration: 30000,
          panelClass: ['red-snackbar']
        })
      });
    }
  }
  clear() {
    this.inputCpf = false;
    this.cpf = undefined;
    this.dataVencimento = undefined;
    this.dataSource.data = [];
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  formataDataAtual() {
    var dia = this.dataVencimento.getDate();
    var mes = this.dataVencimento.getMonth() + 1;
    var ano = this.dataVencimento.getFullYear();
    this.dataFormatada = ano + "-" + (mes < 10 ? ('0' + mes) : mes) + "-" + (dia < 10 ? ('0' + dia) : dia);

  }

}
